$(document).on("click", ".collapsible-tab", function() {
    $('.collapsible-tab').removeAttr("open");
});

function setEqualHeight(columns) {
    var tallestcolumn = 0;
    columns.each(
        function() {
            currentHeight = $(this).height();
            if (currentHeight > tallestcolumn) {
                tallestcolumn = currentHeight;
            }
        }
    );
    columns.height(tallestcolumn);
}
var delay = (function() {
    var timer = 0;
    return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

$(window).resize(function() {
    $('.grid-image-description').css('height', 'auto'); //solve for all you browser stretchers out there!
    setEqualHeight($('.grid-image-description'));
});

$(document).ready(function() {
    $('.grid-image-description').css('height', 'auto'); //solve for all you browser stretchers out there!
    setEqualHeight($('.grid-image-description'));
});

$(window).resize(function() {
    $('.grid-image-title').css('height', 'auto'); //solve for all you browser stretchers out there!
    setEqualHeight($('.grid-image-title'));
});
$(document).ready(function() {
    $('.grid-image-title').css('height', 'auto'); //solve for all you browser stretchers out there!
    setEqualHeight($('.grid-image-title'));
    $('.linklist-filter').on('change', function() {
        location.href = $(this).val();
    })

    $('.text-wrap__Text p').each(function() {
        var controls = $(this).text();
        console.log(controls);

        if (controls.indexOf('®') != -1) {
            if (controls.indexOf('®') > 1) {
                var g = controls.split("®");
                console.log(g);

                var texts = '<span class="m-r">' + g[0] + '</span>' + '<span class="symbol-r">' + '</span>' + '<span class="aligned-right">' + g[1] + '</span>';
                $(this).html(texts);
            }

        }
    });
});

$(document).ready(function() {
    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });


});

$(document).ready(function() {

    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function() {
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
        $('.tab-content').hide();
        var activeTab = $(this).find('a').attr('href');
        var collId = $(this).find('a').data('collection-id');

        $(activeTab).fadeIn();

        // Initiate slider on click.
        $('.main-carousel-' + collId).flickity({
            // options
            cellAlign: 'left',
            contain: true,
            groupCells: 4,
        });

        return false;
    });

    // Initiate click event to load the first slider.
    $("#tabs-nav li:first").trigger("click");
  
    /* Gallery Collection Custom Js -- Start */
    $('.Gallery_Main_ul li:first-child a').addClass('active');
    $('.gallery-products').hide();
    // $('.gallery-products:first').show();


    /* Click function */
    $('.Gallery_Main_Inner a').click(function() {
        var t = $(this);
        $('.Gallery_Main_ul li a').removeClass('active');
        t.addClass('active');
        $('.gallery-products').hide();
        var activeTabGallery = t.data('tab-gallery');
        $('.' + activeTabGallery).fadeIn();
        return false;
    });
    $('.Gallery_Main_ul li:first-child a').trigger("click");
    /* Gallery Collection Custom Js -- Start */
});

$(window).on("load resize orientationchange", function(event) {
    if (window.matchMedia('(max-width: 770px)').matches) {
        $('.about-grid-slider').flickity({
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: true
        });
    } else {
        $('.about-grid-slider').flickity('destroy');
    }
});

$(document).ready(function() {
  $('.popup-youtube').magnificPopup({
    type: 'iframe'
  });

  // var findAward = jQuery( ".gallary-block" ).find('.gallery-image-badge');

  // if(findAward){
  //    var imageDescription = jQuery(".gallary-block").find('.gallary-overlay p');
  //   jQuery('.image-description').append(imageDescription);
    
  //   var bottomText = jQuery(".gallary-block").find('.bottom-gallery-overlay');
  //   $('.bottom_text').append(bottomText);
  // }else{
    
  // }

  // $('.accordion_headings').on('click',function(){
  //   $('.accordion_text').removeClass('show');
  //   $(this).siblings().addClass('show');
  // });


  
  $(".custom_accordion > .accordion_headings").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".accordion_text")
        .slideUp(200);
    } else {
      $(".custom_accordion > .accordion_headings").removeClass("active");
      $(this).addClass("active");
      $(".accordion_text").slideUp(200);
      $(this)
        .siblings(".accordion_text")
        .slideDown(200);
    }
  });


  setTimeout(() => {
      $('.gallary-block-awards').each(function(i, ele) {
      var $elementToBeCloned =  $(ele).removeClass("gallary-block-awards").clone();
      $('.gallery-products.awards > div > div').append($elementToBeCloned);
    });

      $('.gallary-block').each(function(i, ele) {
      var $elementToBeCloned =  $(ele).clone();
      $('.gallery-products.all > div > div').append($elementToBeCloned);
    });
  
  }, "1000");
});